import './js/header-burger';
import './js/categories';
import './js/mainshelf';
import './js/support-ukraine';
import './js/book-modal2';
import './js/site-theme';
import './js/best-sellers';
import './js/btntop.js';
import './js/header.js';
import './js/firebase-btns.js';
import './js/firebase-functions.js';
import './js/firebase-modals.js';